import React from 'react'
import {
  SwapOutlined,
  AlignCenterOutlined,
//   PieChartOutlined,
  SlidersOutlined,
  TeamOutlined,
  ToTopOutlined,
  AuditOutlined
} from '@ant-design/icons';
import Icon from '@ant-design/icons';
import {Menu} from 'antd'
import { useHistory, useLocation } from 'react-router-dom'

// const { SubMenu } = Menu;

import instagramSVG from "../../assets/instagram.svg";
import youtubeSVG from "../../assets/youtube.svg";
import twitterSVG from "../../assets/twitter.svg";
import spotifySVG from "../../assets/spotify.svg";

const instagram = () => (
    <img src={instagramSVG} />
 );
 const youtube = () => (
     <img src={youtubeSVG} />
  );

  const twitter = () => (
    <img src={twitterSVG} />
 );

 const spotify = () => (
    <img src={spotifySVG} />
 );
 

const Menus = ({collapsed}) => {


    const location = useLocation()
    const history = useHistory()

    const onMenuClick =(path)=>{
        history.push(path);
    }
    return (
        <Menu theme="light" selectedKeys={[location.pathname]} 
            mode="inline" collapsedWidth={40} style={{height:"100%"}}>
            {/* <Menu.Item key='/' onClick={() => onMenuClick('/')}
                icon={<PieChartOutlined style={{fontSize: '16px'}} />} >
                Dashboard
            </Menu.Item> */}
            {/* <SubMenu key="sub2" icon={<TeamOutlined style={{fontSize: '16px'}} />} title="Odin Artices"> */}
                <Menu.Item key='/' onClick={() => onMenuClick('/')}
                    icon={<AlignCenterOutlined style={{fontSize: '16px'}} />} >
                    News Feed
                </Menu.Item>
                <Menu.Item key='/news' onClick={() => onMenuClick('/news')}
                    icon={<AuditOutlined style={{fontSize: '16px'}} />} >
                    Market News
                </Menu.Item>
                <Menu.Item key='/chart-breakdowns' onClick={() => onMenuClick('/chart-breakdowns')} icon={<SlidersOutlined style={{fontSize: '16px'}} />}>
                    Chart Breakdows
                </Menu.Item>
                <Menu.Item key='/psychology-mindset' onClick={() => onMenuClick('/psychology-mindset')} icon={<ToTopOutlined style={{fontSize: '16px'}} />}>
                    Psychology & Mindset
                </Menu.Item>
            {/* </SubMenu> */}
            {/* <SubMenu key="sub2" icon={<TeamOutlined style={{fontSize: '16px'}} />} title="Trader Tools">
                <Menu.Item key='/news' onClick={() => onMenuClick('/tools/currencies')}
                    icon={<AuditOutlined style={{fontSize: '16px'}} />} >
                    Currencies Rates
                </Menu.Item>
                <Menu.Item key='/chart-breakdowns' onClick={() => onMenuClick('/chart-breakdowns')} icon={<SlidersOutlined style={{fontSize: '16px'}} />}>
                    Chart Breakdows
                </Menu.Item>
                <Menu.Item key='/psychology-mindset' onClick={() => onMenuClick('/psychology-mindset')} icon={<ToTopOutlined style={{fontSize: '16px'}} />}>
                    Psychology & Mindset
                </Menu.Item>
            </SubMenu> */}
            <Menu.Item key='/services' onClick={() => onMenuClick('/services')}
                icon={<SwapOutlined style={{fontSize: '16px'}} />}>
                Services & Education
            </Menu.Item>
            <Menu.Item key='/roadmap' onClick={() => onMenuClick('/roadmap')}
                icon={<TeamOutlined style={{fontSize: '16px'}} />} >
                Roadmap
            </Menu.Item>
            {/* <Menu.Item key="5" icon={<TeamOutlined style={{fontSize: '16px'}} />}>
                Refferals
            </Menu.Item> */}

            { collapsed ?
                <>
                <Menu.Item title={"Instagram"}>
                    <Icon component={instagram} style={{width:20, height:20}}
                        onClick={()=>{ window.open('https://www.instagram.com/odinplatform')}}
                    />
                </Menu.Item >

                <Menu.Item title={"Youtube"}>
                    <Icon component={youtube} style={{width:20, height:20}}
                        onClick={()=>{ window.open('https://www.youtube.com/channel/UCnhqr1ILge94zpGBQ0jQdWw')}}
                        />
                </Menu.Item >
                <Menu.Item title={"Twitter"}>
                    <Icon component={twitter} style={{width:20, height:20}}
                        onClick={()=>{ window.open('https://twitter.com/odintraders')}}
                        />
                </Menu.Item >
                <Menu.Item title={"Spotify"}>
                    <Icon component={spotify} style={{width:20, height:20 }}
                        onClick={()=>{ window.open('https://open.spotify.com/show/6Z4u7CBD6KwaM65koRqcp5')}}
                        />
                </Menu.Item>
                </>
                :
                <Menu.Item >
                    <Icon component={instagram} style={{width:20, height:20, marginTop:15,marginLeft:5}}
                        onClick={()=>{ window.open('https://www.instagram.com/odinplatform')}}
                    />
                    <Icon component={youtube} style={{width:20, height:20, marginTop:15,marginLeft:5}}
                        onClick={()=>{ window.open('https://www.youtube.com/channel/UCnhqr1ILge94zpGBQ0jQdWw')}}
                        />
    
                    <Icon component={twitter} style={{width:20, height:20, marginTop:15,marginLeft:5}}
                        onClick={()=>{ window.open('https://twitter.com/odintraders')}}
                        />
    
                    <Icon component={spotify} style={{width:20, height:20, marginTop:15,marginLeft:5}}
                        onClick={()=>{ window.open('https://open.spotify.com/show/6Z4u7CBD6KwaM65koRqcp5')}}
                        />
                </Menu.Item>

            }
            
      </Menu>
    )
}

export default Menus
